import { useQuery } from '@tanstack/react-query';

import { Customer } from '../../types/Account';
import { Services } from './services';

export const useAccountInformation = () => {
	return useQuery<Customer>(['account-information'], () => Services.getCustomerInformation());
};
